/**
 * @generated SignedSource<<9506e5574c7f5c03cf4c731861dd2e86>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetTagsQuery$variables = Record<PropertyKey, never>;
export type AssetTagsQuery$data = {
  readonly assetTags: ReadonlyArray<{
    readonly groups: ReadonlyArray<{
      readonly label: string | null | undefined;
      readonly translation: string | null | undefined;
    }>;
    readonly label: string | null | undefined;
    readonly translation: string | null | undefined;
  }>;
};
export type AssetTagsQuery = {
  response: AssetTagsQuery$data;
  variables: AssetTagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translation",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetTagMapping",
    "kind": "LinkedField",
    "name": "assetTags",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetTagGroup",
        "kind": "LinkedField",
        "name": "groups",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetTagsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AssetTagsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ed1f79452b05a5f09fb2d9e2f3f8322d",
    "id": null,
    "metadata": {},
    "name": "AssetTagsQuery",
    "operationKind": "query",
    "text": "query AssetTagsQuery {\n  assetTags {\n    label\n    translation\n    groups {\n      label\n      translation\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "34ece4d4e3e5c58e5be3e5d02ac41534";

export default node;
